<template>
    <v-content>
        <v-container fluid grid-list>
            <v-layout row align-center justify-center mt-4>
                <v-flex xs3 sm3 md3>
                    <img src="http://dev.sozpic.com/lemon-gestor-v2/logo.png" style="max-width: 100%">
                </v-flex>
            </v-layout>

            <v-layout row align-center justify-center mt-3>
                <v-flex xs12 sm6 md5>
                    <v-flex xs12>
                        <h2>Importar samples created_At:</h2>
                    </v-flex>
                    <v-flex xs12 class="mt-1">
                        <vue-dropzone ref="myVueDropzone" id="dropzone4" :options="dropzoneOptions"></vue-dropzone>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { API_BASE } from  '../../../config';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        data : function() {
            return {
                dropzoneOptions: {
                    url: API_BASE + 'import/samples',
                    thumbnailWidth: 150,
                    maxFilesize: 50000,
                    headers: { 
                        'Authorization' : localStorage.getItem('token'),
                        'Autrollization' : localStorage.getItem('token'),
                        'Authorization-temp' : localStorage.getItem('token')
                    },
                    addRemoveLinks: true,
                },
            }
        },
        methods : {

        },
        components: {
            vueDropzone: vue2Dropzone
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/samples/ImportComponent.vue